var _circle, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFaqs9(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 62,
    r: 61,
    stroke: "#339999",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.5883 68.4775H48.1592C45.4648 68.4775 42.8808 69.5479 40.9756 71.4531C39.0703 73.3583 38 75.9424 38 78.6367V83.7163",
    stroke: "#339999",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84.6764 72.6072C85.6882 71.5954 86.2566 70.2232 86.2566 68.7924C86.2566 67.3616 85.6882 65.9893 84.6764 64.9776C83.6647 63.9659 82.2925 63.3975 80.8616 63.3975C79.4308 63.3975 78.0586 63.9659 77.0469 64.9776L66.8623 75.1673C66.2584 75.7708 65.8164 76.5168 65.5771 77.3363L63.4513 84.6255C63.3876 84.844 63.3837 85.0757 63.4402 85.2962C63.4967 85.5168 63.6115 85.718 63.7725 85.879C63.9334 86.04 64.1347 86.1547 64.3552 86.2112C64.5758 86.2677 64.8074 86.2639 65.026 86.2002L72.3152 84.0744C73.1347 83.8351 73.8807 83.3931 74.4842 82.7892L84.6764 72.6072Z",
    stroke: "#339999",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7786 58.3184C61.3894 58.3184 65.9378 53.77 65.9378 48.1592C65.9378 42.5484 61.3894 38 55.7786 38C50.1678 38 45.6194 42.5484 45.6194 48.1592C45.6194 53.77 50.1678 58.3184 55.7786 58.3184Z",
    stroke: "#339999",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFaqs9);
export default __webpack_public_path__ + "static/media/IconFaqs9.a453325794ac22db5fc9c88e16c3893c.svg";
export { ForwardRef as ReactComponent };